import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { KpiResultFragment, KpiType } from "@ankaadia/graphql";
import { NewUiKpiGridPanelComponent } from "../kpi-grid-panel/new-ui-kpi-grid-panel.component";

@Component({
  selector: "new-ui-kpi-grid-view",
  templateUrl: "./new-ui-kpi-grid-view.component.html",
  styleUrl: "./new-ui-kpi-grid-view.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewUiKpiGridPanelComponent],
})
export class NewUiKpiGridViewComponent {
  readonly candidateKpis = input.required<KpiResultFragment[]>();
  readonly organizationKpis = input.required<KpiResultFragment[]>();
  readonly revenueKpis = input.required<KpiResultFragment[]>();
  readonly accountsReceivableKpis = input.required<KpiResultFragment[]>();

  readonly KpiType = KpiType;
}
